// client/src/routes/app/properties/$propertyId/costs.tsx — SCR-PROP-003 tab „Costuri & P&L
// economic" · EXP-005 phase 2 (04 §8.3; 05 §12.1 demo path 6, the surface the M2 exit named as
// unowned).
//
// The route owns the URL state — the P&L's basis/period/year and the ledger's filters, one
// schema (`costs-search.ts`) — and the tab reads it back typed. `Expenses.Read` on top of the
// layout's `Portfolio.Read`: the ledger half is the register's own reading and is gated as the
// register is (D-725's split), so a member who may see the property but not its costs gets
// SCR-SYS-403 here rather than a tab full of errors.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { CostsTab } from '@/features/properties/CostsTab';
import {
  propertyCostsSearchSchema,
  type PropertyCostsSearch,
} from '@/features/properties/costs-search';

export const Route = createFileRoute('/app/properties/$propertyId/costs')({
  validateSearch: propertyCostsSearchSchema,
  component: CostsScreen,
});

function CostsScreen() {
  const { propertyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Expenses.Read">
      <CostsTab
        propertyId={propertyId}
        search={search}
        onSearchChange={(next: (previous: PropertyCostsSearch) => PropertyCostsSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
